// extracted by mini-css-extract-plugin
export default {"carousel":"Carrusel_carousel__NaJwt","slide":"Carrusel_slide__Clr8A","arrow":"Carrusel_arrow__H82EH"};